import { render } from "./AppointmentCard.vue?vue&type=template&id=37eb718a&scoped=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"

import "./AppointmentCard.vue?vue&type=style&index=0&id=37eb718a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37eb718a"]])

export default __exports__